import type {
  TChatHistoryBody as TChatHistoryBodyContract,
  TChatRatingReason,
  TChatStreamBody as TChatStreamBodyContract,
  TChatStreamDoneEvent,
  TSimChatRatingReason,
  TThinkingStepDto
} from '@homepal/api-contract'

import { TMetricView } from 'types/GlobalMetric'

// The runtime list of reasons the chips render; the contract is types-only.
export const CHAT_RATING_REASONS: TChatRatingReason[] = [
  'wrong_numbers',
  'not_answered',
  'cannot_help'
]

// The reasons the SIM modelling chat offers for a thumbs down.
export const SIM_CHAT_RATING_REASONS: TSimChatRatingReason[] = [
  'wrong_proposal',
  'board_unchanged',
  'misunderstood',
  'other'
]

// Wrapped in `{ data }` by the client.
export type TChatStreamBody = TChatStreamBodyContract<TMetricView>

export type TChatHistoryBody = TChatHistoryBodyContract<TMetricView>

// Callbacks invoked as SSE events arrive from the stream.
export type TChatStreamCallbacks = {
  onStart: (data: { chat_id: string; title: string }) => void
  onToolStart: (data: { tool: string; input: Record<string, unknown> }) => void
  onToolEnd: (data: TThinkingStepDto) => void
  onText: (delta: string) => void
  onReasoning: (delta: string) => void
  onDone: (data: TChatStreamDoneEvent) => void
  onError: (message: string) => void
  onReadOnly: () => void
}
